import { useMemo, useState } from "react";
import { PaymentMethod } from "../../../../../api/tournament-participant";
import { Const } from "../../../../../common/const/const";
import { DialogPayType } from "../components/more";

export const useDialogPayTypes = () => {
  const [cash, setCash] = useState<number>(0);
  const [card, setCard] = useState<number>(0);
  const [bank, setBank] = useState<number>(0);
  const [point, setPoint] = useState<number>(0);
  const [discount, setDiscount] = useState<number>(0);
  const [seed, setSeed] = useState<number>(0);

  const dialogPayType: DialogPayType[] = useMemo(() => {
    const base: DialogPayType[] = [
      {
        name: "현금",
        type: PaymentMethod.CASH,
        value: cash,
        unit: "원",
        set: setCash,
      },
      {
        name: "신용카드",
        type: PaymentMethod.CARD,
        value: card,
        unit: "원",
        set: setCard,
      },
      {
        name: "계좌",
        type: PaymentMethod.BANK_TRANSFER,
        value: bank,
        unit: "원",
        set: setBank,
      },
      {
        name: "매장 이용권",
        type: PaymentMethod.POINTS,
        value: point,
        unit: "E",
        set: setPoint,
      },
      {
        name: "할인",
        type: PaymentMethod.DISCOUNT,
        value: discount,
        unit: "",
        set: setDiscount,
      },
      {
        name: "크레딧",
        type: PaymentMethod.SEED,
        value: seed,
        unit: "RABBIT",
        set: setSeed,
      },
    ];

    return base;
  }, [cash, card, bank, point, discount, seed]);

  const resetDialogPayType = () => {
    for (const type of dialogPayType) {
      type.set?.(0);
    }
  };

  const handleDialogTypeSet = (type: PaymentMethod, value: number) => {
    switch (type) {
      case PaymentMethod.CARD:
        setCard(value);
        break;
      case PaymentMethod.CASH:
        setCash(value);
        break;
      case PaymentMethod.BANK_TRANSFER:
        setBank(value);
        break;
      case PaymentMethod.DISCOUNT:
        setDiscount(value);
        break;
      case PaymentMethod.POINTS:
        setPoint(value);
        break;
      case PaymentMethod.SEED:
        setSeed(value);
        break;
    }
  };

  const handleSetPaymentValues = (item: any, isTempItem = false) => {
    const payments =
      item.paymentMethodRequests || item.participantPaymentMethod;

    for (const payment of payments) {
      const amount = payment.paymentAmount || payment.amount;
      const value =
        payment.paymentMethod === PaymentMethod.SEED && isTempItem
          ? amount / Const.SEED_RATE
          : amount;

      switch (payment.paymentMethod) {
        case PaymentMethod.CARD:
          setCard(value);
          break;
        case PaymentMethod.CASH:
          setCash(value);
          break;
        case PaymentMethod.BANK_TRANSFER:
          setBank(value);
          break;
        case PaymentMethod.DISCOUNT:
          setDiscount(value);
          break;
        case PaymentMethod.POINTS:
          setPoint(value);
          break;
        case PaymentMethod.SEED:
          setSeed(value);
          break;
      }
    }
  };

  return {
    dialogPayType,
    resetDialogPayType,
    handleSetPaymentValues,
    handleDialogTypeSet,
  };
};
